import { makeAutoObservable } from "mobx";
import { appStore } from "src/appStore";
import {
  ClassifierFilters,
  classifiersLoader,
  ZClassifier,
} from "src/business/classifier";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import { buildClassifiersColumns } from "./buildClassifiersColumns";

export const classifiersPageStore = makeAutoObservable({
  get tableStore() {
    return new RtStore<ZClassifier, ClassifierFilters>({
      rowKey: "id",
      loader: classifiersLoader,
    });
  },
  get columns() {
    return buildClassifiersColumns(!!appStore.isMetadataEditor);
  },
});
